module.exports = __webpack_public_path__ + "static/media/videoEditor-7.62622207.webp";